// API service for supply management
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class SupplyService {
  static async getAllSupplies(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/supplies`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching all supplies:', error);
      throw error;
    }
  }

  static async getSupplies(token, limit = 50, lastKey = null) {
    try {
      let url = `${API_BASE_URL}/supplies?limit=${limit}`;
      if (lastKey) {
        url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        supplies: data.data,
        pagination: data.pagination
      };
    } catch (error) {
      console.error('Error fetching supplies:', error);
      throw error;
    }
  }

  static async getSupplyById(supplyId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/supplies/${supplyId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching supply:', error);
      throw error;
    }
  }

  static async createSupply(supplyData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/supplies`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(supplyData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error creating supply:', error);
      throw error;
    }
  }

  static async updateSupply(supplyId, supplyData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/supplies/${supplyId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(supplyData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error updating supply:', error);
      throw error;
    }
  }

  static async deleteSupply(supplyId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/supplies/${supplyId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting supply:', error);
      throw error;
    }
  }

  static async searchSupplies(query, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/supplies/search?query=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error searching supplies:', error);
      throw error;
    }
  }

  static async getSupplyStats(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/supplies/stats`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching supply stats:', error);
      throw error;
    }
  }
}

export default SupplyService;
